import {
  fetchCollection,
  fetchResource
} from './index'

import { locationSchema as schema } from '../schemas'

const singleKey = 'location'
const multipleKey = 'locations'

export const LOCATIONS_REQUEST = 'LOCATIONS_REQUEST'
export const LOCATIONS_SUCCESS = 'LOCATIONS_SUCCESS'
export const LOCATIONS_FAILURE = 'LOCATIONS_FAILURE'

function fetchLocations (url, reload) {
  return fetchCollection({
    url,
    key: multipleKey,
    actions: [LOCATIONS_REQUEST, LOCATIONS_SUCCESS, LOCATIONS_FAILURE],
    schema,
    responseInterceptor: (response) => ({ ...response, reload })
  })
}

export function loadLocations (nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl,
      pageCount
    } = getState().pagination.locations

    if (!nextPage) {
      nextPageUrl = '/locations'
    }

    if (nextPage || !pageCount) {
      return dispatch(fetchLocations(nextPageUrl, !nextPage))
    }
  }
}

export const LOCATIONS_ALL_REQUEST = 'LOCATIONS_ALL_REQUEST'
export const LOCATIONS_ALL_SUCCESS = 'LOCATIONS_ALL_SUCCESS'
export const LOCATIONS_ALL_FAILURE = 'LOCATIONS_ALL_FAILURE'

export function loadAllLocations () {
  return (dispatch, getState) => {
    let nextPageUrl = '/locations?per_page=all'
    return dispatch(fetchCollection({
      url: nextPageUrl,
      key: multipleKey,
      actions: [LOCATIONS_ALL_REQUEST, LOCATIONS_ALL_SUCCESS, LOCATIONS_ALL_FAILURE],
      schema,
      responseInterceptor: (response) => ({ locations: response.entities.locations })
    })
    )
  }
}

export function loadAllLocationsForCalendar () {
  return (dispatch, getState) => {
    let nextPageUrl = '/locations?per_page=all'
    // return dispatch(fetchCollection({
    //   url: nextPageUrl,
    //   key: multipleKey,
    //   actions: [LOCATIONS_ALL_REQUEST, LOCATIONS_ALL_SUCCESS, LOCATIONS_ALL_FAILURE],
    //   schema,
    //   responseInterceptor: (response) => ({ ...response, reload: true })
    // })
    // )
    return dispatch(fetchLocations(nextPageUrl, true))
  }
}

export function searchLocations (searchQuery, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl,
      pageCount
    } = getState().pagination.locations

    if (!nextPage) {
      nextPageUrl = `/locations?search=${searchQuery}`
    }

    return dispatch(fetchLocations(nextPageUrl, !nextPage))
  }
}

export const LOCATION_REQUEST = 'LOCATION_REQUEST'
export const LOCATION_SUCCESS = 'LOCATION_SUCCESS'
export const LOCATION_FAILURE = 'LOCATION_FAILURE'

export function fetchLocation (locationId, query = {}) {
  return fetchResource({
    url: `/locations/${locationId}`,
    key: singleKey,
    schema,
    query,
    actions: [LOCATION_REQUEST, LOCATION_SUCCESS, LOCATION_FAILURE]
  })
}



// WEBPACK FOOTER //
// ./src/actions/locations.js